import { accessManagerRoutes } from "./router";
/**
 * Access Manager Module — admin user & rights management.
 * Lot 1: users list view at /workspace/users, gated by
 * `meta.requiresCapability: "accessmanager.manage-users"`. The gated nav entry
 * lives in SettingsSidebar (Workspace management).
 */
export class AccessManagerModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[AccessManagerModule] Registered");
        return { id: "access-manager", name: "Access Manager Module", version: "1.0.0" };
    }
    getRoutes() {
        return accessManagerRoutes;
    }
    getNavigationItems() {
        return [];
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[AccessManagerModule] Unregistered");
        this.contracts = null;
    }
}
export default new AccessManagerModule();
